import { Inject } from 'vue-di-container';
import { Component, Vue } from 'vue-property-decorator';

import MortgagesService from '@/Services/MortgagesService';
import WithRender from './IndexPage.html';
import DataTable from '@t2/data-table';
import GStatic from '@/Services/GStatic';
import FilterComponent from '@/components/FilterComponent.vue';
import { MortageSearch } from '@/models/models';

@WithRender
@Component({
    components: {
        DataTable,
        FilterComponent
    },
    diProvide: [
        MortgagesService
    ],
})
export default class IndexPage extends Vue {
    @Inject(MortgagesService) public mortgagesService!: MortgagesService;
    public searchActivated = false
    public isLoading = false;
    public selectedTab = 0;
    public openedInstitutionId = '';
    public userOpeningSessionId = null
    public pendingmortgages: any[] = [];
    public elsemortgages: any[] = [];

    public mortgages: any[] = [];

    public records: any[] = [];

    public recordsFiltered: any[] = [];

    public showFilters: boolean = false;
    public filter: MortageSearch = {} as MortageSearch; //any = {};
    public pager = {
        currentPage: 1,
        totalPages: 1,
        pageSize: 10
    };
    public institute = false
    public fireToClose = false;
    public recordsCount: number = 0;
    public viewAlertDiv = false;
    public alertText = '';
    public filterData: any = { fullForm: {} };
    public dataTableConfig = {
        card_mode: false,
        show_refresh_button: false,
        show_reset_button: false,
        global_search: {
            visibility: false,
        },
        pagination: false,
        per_page: 10,
        per_page_options: [10, 25, 50, 100],
        server_mode: false,
        page: this.pager.currentPage,
        dir: 'rtl',
    };
    MortgagesService: any;
    sort: any;

    loadDataFromMounted = false;
    
    public async mounted() {
        this.loadDataFromMounted = true;
        if(!this.$route.params.status) {
            await this.fillData(1);
        }
        if(this.$route.params.status) await this.showAlert(this.$route.params)
        this.recordsCount = this.records.length;
        this.isLoading = false;
    }

    public async showAlert(route: any) {
        await this.fillData(1);
        let paramsStatus = route.status[route.status.length -1]
        // this.viewAlertDiv = false
        if(paramsStatus === 'A') {
            this.alertText = route.status.slice(0,-1)
            this.viewAlertDiv = true
        }
        if(paramsStatus === 'R') {
            this.filterTabList.forEach((elm) => elm.isSelected = false);
            this.selectedTab = 1;
            this.filterTabList[1].isSelected = true;

            this.pager.currentPage = 1;
            

            this.filter.dataFlag = this.selectedTab;
            await this.fillData(1)
            this.alertText = route.status.slice(0,-1)
            this.viewAlertDiv = true
        }
    }
    public getColor(color: number) {
        return GStatic.Vars.MortgagesStatusColors[color];
    }


    public async fillData(page:number) {
        this.isLoading = true;
        this.filter.CurrentPage = page;
        this.filter.dataFlag = this.selectedTab;
        this.filter.PageSize = this.pager.pageSize;
        // this.filter.InstitutionId = '7002391600';

        // console.log('fillData called');
        // console.log('this.filter', this.filter);
        //debugger;

        const ev = await this.mortgagesService.GetAll(this.filter, this.pager.currentPage);
        if(ev.status != 200) {
            this.records = []
        };
        if (ev && ev.data && !ev.data.isError && ev.data.result) {
            if (this.loadDataFromMounted && ev.data.result.Records.length == 0)
                this.records = [];
            else
                this.records = ev.data.result.Records;
                this.institute = ev.data.isImpersonated
                this.openedInstitutionId = ev.data.InstitutionId
                this.userOpeningSessionId = ev.data.sessionOpenedBy
                

            this.pager.totalPages = ev.data.result.TotalPages;
            this.pager.currentPage = ev.data.result.CurrentPage;
            this.pager.pageSize = ev.data.result.PageSize;
        } else {
            if (this.loadDataFromMounted && ev.data.result == null)
                this.records = [];
            else
                this.records = [];

            this.pager.totalPages = 0;
            this.pager.currentPage = 1;
        }
    }
    public get instituteColumns() {
        return [
            {
                name: 'Id',
                label: this.selectedTab == 0 ? 'رقم الرهن' : 'رقم الطلب',
            },
           
            {
                name: 'lstPersonInfo',
                label: this.selectedTab == 0 ? 'اسم الراهن' : 'اسم مقدم الطلب',
            },
            {
                name: 'MorgtgeeName',               
                label: this.selectedTab == 0 ? 'اسم المرتهن' : 'اسم المرتهن',
            },
            {
                name: 'MortgageIssueDate',
                label: this.selectedTab == 0 ? 'تاريخ إصدار الوثيقة' : 'تاريخ إنشاء الطلب',
            },
            {
                name: 'MortgageStatusText',
                label: this.selectedTab == 0 ? 'حالة الرهن' : 'حالة الطلب',
            },
            {
                name: 'IsInstitutionIdMortgagee',
                label: 'نوع الطرف للمنشأة',
            }
        ];
    } public get requestColumns() {
        return [
            {
                name: 'Id',
                label: this.selectedTab == 0 ? 'رقم وثيقة الرهن' : 'رقم الطلب',
            },
            {
                name: 'MorgtgeeName',
                label: 'اسم المرتهن',
             },
            // {https://najiz2.moj.gov.sa/applications/mortgages
            {
                name: 'MortgageIssueDate',
                label: this.selectedTab == 0 ? 'تاريخ إصدار الوثيقة' : 'تاريخ إنشاء الطلب',
            },
            
            // {
            //     name: 'lstPersonInfo',
            //     label: 'حالة الأعتماد',
            // },
            {
                name: 'MortgageStatusText',
                label: this.selectedTab == 0 ? 'حالة الرهن' : 'حالة الطلب',
            },
            
        ];
    }
    public get columns() {
        return [
            {
                name: 'Id',
                label: this.selectedTab == 0 ? 'رقم وثيقة الرهن' : 'رقم الطلب',
            },
            {
                name: 'MorgtgeeName',
                label: 'اسم المرتهن',
             },
            {
                name: 'MortgageIssueDate',
                label: this.selectedTab == 0 ? 'تاريخ إصدار الوثيقة' : 'تاريخ إنشاء الطلب',
            },
            // {
            //     name: 'lstPersonInfo[0]',
            //     label: this.selectedTab == 0 ? 'اسم الراهن' : 'اسم مقدم الطلب',
            // },
            //{
              //  name: 'MortgageTypeText',
               // label: 'نوع الرهن',
           // },
            // {
            //    name: 'MorgtgeeName',
            //    label: 'اسم المرتهن',
            // },
            {
                name: 'MortgageStatusText',
                label: this.selectedTab == 0 ? 'حالة الرهن' : 'حالة الطلب',
            }
        ];
    }
    public filterInstituteTabList = [
        {
            name: 'list',
            label: 'قائمة الرهون',
            isSelected: true,
            filter: 'status-neq-new',
        },
    ];

    public filterTabList = [
        {
            name: 'list',
            label: 'قائمة الرهون',
            isSelected: true,
            filter: 'status-neq-new',
        },
        {
            name: 'requests',
            label: 'قائمة الطلبات',
            isSelected: false,
            filter: 'status:eq:new,createdDate:gt:20201202,name:like:احمد علي حسن',
        }
    ];
    public getRows() {
        return this.selectedTab === 0 ? this.elsemortgages : this.pendingmortgages;
    }

    public async changeFilterTab(index: number) {
        this.filterTabList.forEach((elm) => elm.isSelected = false);
        this.selectedTab = index;
        this.filterTabList[index].isSelected = true;
        
        this.pager.currentPage = 1;
        this.filter.dataFlag = this.selectedTab;
        this.fireToClose = !this.fireToClose;
        this.clearSearch();
        this.viewAlertDiv = false
        
    }

    public async changePage(event: any) {
        //console.log("this.filter: ", this.filter);
        // this.filter.CurrentPage = this.pager.currentPage;
        this.loadDataFromMounted = false;
        this.isLoading = true;
        await this.fillData(this.pager.currentPage);
        this.isLoading = false;
        //
    }

    public get filterFields() {
        this.filterData = event;
        // console.log("filterData", this.selectedTab);
        let filtersArray =[]
        if(!this.institute) {
            if (this.selectedTab == 0) {
                filtersArray = [
                    {
                        type: 'select',
                        name: 'byid',
                        label: 'البحث بواسطة',
                        css: '',
                        options: [
                            { label: 'اختر', value: undefined },
                            { label: 'رقم وثيقة الرهن', value: '1' },
                            { label: 'تاريخ إصدار الوثيقة ', value: '2' },
    
                        ],
                        defaultValue: undefined,
    
                    }, {
                        type: 'select',
                        name: 'status',
                        label: ' حالة الرهن',
                        css: '',
                        options: [
                            { label: 'اختر', value: undefined },
                            { label: 'معتمد', value: '3' },
    
                            { label: 'منتهي', value: '4' },
    
                        ],
                        defaultValue: undefined,
    
                    }
    
                ];
            } else {
                filtersArray = [
                    {
                        type: 'select',
                        name: 'byid',
                        label: 'البحث بواسطة',
                        css: '',
                        options: [
                            { label: 'اختر', value: undefined },
                            { label: 'رقم الطلب', value: '1' },
                            { label: 'تاريخ إنشاء الطلب', value: '2' },
    
                        ],
                        defaultValue: undefined,
                    }, {
                        type: 'select',
                        name: 'status',
                        label: ' حالة الطلب',
                        css: '',
                        options: [
                            { label: 'اختر', value: undefined },
                            { label: 'ملغى', value: '6' },
                            { label: 'في انتظار الاعتماد', value: '2' }
                        ],
                        defaultValue: undefined,
                    }
                ];
            }
        } else {
            if (this.selectedTab == 0) {
                filtersArray = [
                    {
                        type: 'select',
                        name: 'byid',
                        label: 'البحث بواسطة',
                        css: '',
                        options: [
                            { label: 'اختر', value: undefined },
                            { label: 'رقم وثيقة الرهن', value: '1' },
                            { label: 'تاريخ إصدار الوثيقة ', value: '2' },
                            { label: 'رقم المنشأة', value: '3' },
    
    
                        ],
                        defaultValue: undefined,
    
                    }, {
                        type: 'select',
                        name: 'status',
                        label: ' حالة الرهن',
                        css: '',
                        options: [
                            { label: 'اختر', value: undefined },
                            { label: 'معتمد', value: '3' },
    
                            { label: 'منتهي', value: '4' },
    
                        ],
                        defaultValue: undefined,
    
                    },
                    {
                        type: 'select',
                        name: 'instituteType',
                        label: 'نوع الطرف',
                        css: '',
                        options: [
                            { label: 'اختر', value: undefined },
                            { label: 'راهن و مرتهن', value: '1' },
                            { label: 'مرتهن', value: '2' },
                            { label: 'راهن', value: '3' },
    
    
                        ],
                        defaultValue: undefined,
    
                    }
    
                ];
            } else {
                filtersArray = [
                    {
                        type: 'select',
                        name: 'byid',
                        label: 'البحث بواسطة',
                        css: '',
                        options: [
                            { label: 'اختر', value: undefined },
                            { label: 'رقم الطلب', value: '1' },
                            { label: 'تاريخ إنشاء الطلب', value: '2' },
                            { label: 'رقم المنشأة', value: '3' },
    
                        ],
                        defaultValue: undefined,
                    }, {
                        type: 'select',
                        name: 'status',
                        label: ' حالة الطلب',
                        css: '',
                        options: [
                            { label: 'اختر', value: undefined },
                            { label: 'ملغى', value: '6' },
                            { label: 'في انتظار الاعتماد', value: '2' }
                        ],
                        defaultValue: undefined,
                    },
                    {
                        type: 'select',
                        name: 'instituteType',
                        label: 'نوع الطرف',
                        css: '',
                        options: [
                            { label: 'اختر', value: undefined },
                            { label: 'راهن و مرتهن', value: '1' },
                            { label: 'مرتهن', value: '2' },
                            { label: 'راهن', value: '3' },
    
    
                        ],
                        defaultValue: undefined,
    
                    }
                ];
            }
        }
        
       
        return filtersArray
    }

    public async onFilterChanged(event: any) {
    //    console.log(event.fullForm, 'fullForm')
        if( event.fullForm.search.length > 0 && Number(event.fullForm.search) === 0) {
            this.records = []
            this.pager.totalPages = 1
            return;
        };
        // if(event.fullForm.search === "" && event.fullForm.byid === undefined && event.fullForm.status === undefined) {
        //     console.log('started')
        // }
        if (event.fullForm.search != "") {
            this.filter.ApplicationId = undefined
            if (event.fullForm.byid != undefined) {
                if (event.fullForm.byid == '1')
                    this.filter.ApplicationId = event.fullForm.search;
                else
                    if (event.fullForm.byid == '2') {
                        // console.log('1')
                        // this.filter.ApplicationId = ''
                        this.filter.IssueDate = event.fullForm.search;
                        // console.log(this.filter.IssueDate, '11')
                    }
            } else {
                if(!this.filter.IssueDate)
                    this.filter.ApplicationId = event.fullForm.search;
            }
        }
        // console.log(this.filter.ApplicationId, 'first assign')
        if (event.fullForm.RahenType || event.fullForm.status || event.fullForm.byid) {
            this.records = [];
            this.filter.MortgageType = event.fullForm.RahenType;
            this.filter.Statuses = event.fullForm.status ? [event.fullForm.status] : [] //event.fullForm.search ? [event.fullForm.status] : [];

            if (event.fullForm.byid == '1')
                this.filter.ApplicationId = event.fullForm.search;
            else if (event.fullForm.byid == '2') {
            //    delete  this.filter.ApplicationId
                // console.log('2')
                this.filter.IssueDate = event.fullForm.search;
                // console.log(event.fullForm, 'form');
                // console.log(event.fullForm.search, 'search');
            }

        }
        if(this.institute) {
            this.filter.IsInstitutionsSearch = true;
            this.filter.InstitutionId = this.openedInstitutionId
            if(event.fullForm.instituteType !== undefined) this.filter.InstitutionsSearchType = Number(event.fullForm.instituteType)
            if(event.fullForm.byid === '3') this.filter.InstitutionIdentifier = event.fullForm.search

        }
        // console.log(this.filter.ApplicationId, 'second assign')
        this.loadDataFromMounted = false;
        this.fillData(1);
        this.filter.ApplicationId = undefined
        this.searchActivated = true
        this.isLoading = false;
    }
   
    public async clearSearch() {
        this.filter.MortgageType = 0;
        this.filter.Statuses = [];
        this.filter.ApplicationId = 0;
        this.filter.IssueDate = "";
    }

    public async FilterResult() {
        const ev = await this.mortgagesService.GetAllData(this.filter);
        this.sort = ev.SortFilter;
        this.loadDataFromMounted = false;
        this.fillData(1);
    }

    public getStatusColor(status: number) {
        let color = 'gray';
        if (status == 3)
            return 'green';
        else if (status == 6 || status == 4)
            return 'red';
        else if (status == 2)
            return 'orange';
        return color;
    }



}
